import { isDev as isDevUtils } from './utils';

const isDev = isDevUtils();

export const logger = {
    debug: (...args: unknown[]) => {
        if (isDev) {
            console.debug('%c[DEBUG]', 'color: #6495ED', ...args);
        }
    },
    info: (...args: unknown[]) => {
        if (isDev) {
            console.info('%c[INFO]', 'color: #6495ED', ...args);
        }
    },
    warn: (...args: unknown[]) => {
        if (isDev) {
            console.warn('%c[WARN]', 'color: #FFA500', ...args);
        }
    },
    error: (...args: unknown[]) => {
        // Always log errors, even in production
        console.error('%c[ERROR]', 'color: #FF0000', ...args);
    },
};
